/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Weiterebeteiligtepersonen2Inputs */

const de__field_weiterebeteiligtepersonen2 = /** @type {(inputs: _Field_Weiterebeteiligtepersonen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`weitere beteiligte Personen`)
};

/**

* @param {_Field_Weiterebeteiligtepersonen2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_weiterebeteiligtepersonen2 = /** @type {((inputs?: _Field_Weiterebeteiligtepersonen2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Weiterebeteiligtepersonen2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_weiterebeteiligtepersonen2(inputs)
});
export { _field_weiterebeteiligtepersonen2 as "_field_weitereBeteiligtePersonen" }